import React, {
    useState,
    useRef,
    useContext,
    forwardRef,
    useImperativeHandle,
    useEffect,
} from 'react';
import {Popover, Button, notification, Input, Form, Image} from 'antd';
import {MinusCircleOutlined, PlusOutlined} from '@/icons';
import {attaches} from './attachType';
import LinkFormModal from '@/page/component/LinkFormModal';
import {formLayout} from '@/page/customer/MomentPage/SendMoment/Form/formLayout';
import WelcomUploadModal from '@/page/component/WelcomUploadModal';
import MsgContext from '@/page/customer/WelcomPage/msgContext';
import styles from './index.module.less';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {addCustomerWelcomeConfig, updateCustomerWelcomeConfig} from '@/api/customer';

const {TextArea} = Input;
const ConfigPage = forwardRef(({reload, isEdit}, ref) => {
    // const [textValue, setTextValue] = useState(null);
    const [type, setType] = useState({
        key: 'image',
        label: '图片',
        maxCount: 3,
        maxSize: 2048000, // 10m
        accept: '.png, .jpg, .jpeg',
    });
    const [authStore] = useAuthStore();
    const extId = _.get(authStore, 'user.extId');
    const {
        setViewText,
        setViewLinks,
        setViewImages,
        selectedUsers,
        viewLinks,
        viewImages,
        viewText,
    } = useContext(MsgContext);
    const welcomUploadRef = useRef();
    const linkFormRef = useRef();
    const [visible, setVisible] = useState(false);
    const [key, setKey] = useState(0);
    const [title, setTitle] = useState('');
    const [images, setImages] = useState([]);
    const [links, setLinks] = useState([]);
    const [text, setText] = useState('');
    const [welcomeData, setWelcomeData] = useState({
        attachments: [],
    });

    useEffect(() => {
        if (isEdit) {
            setLinks(viewLinks);
            setImages(viewImages);
            setText(viewText);
        }
    }, []);

    useImperativeHandle(ref, () => ({
        saveOrUpdate,
    }));

    function renderPopoverContent() {
        return (
            <div className={styles.attachContent}>
                {attaches.map(item => (
                    <div
                        className={styles.attachBlock}
                        key={item.key}
                        onClick={() => {
                            selectType(item.key);
                        }}
                    >
                        {item.value}
                    </div>
                ))}
            </div>
        );
    }

    function selectType(selectKey) {
        setKey(selectKey);
        if (links.length + images.length >= 3) {
            notification.warn({
                message: '最多添加三个附件',
            });
            return;
        }
        console.log(selectKey);
        if (selectKey === 0) linkFormRef.current.open('LINK', true);
        if (selectKey === 1) {
            setTitle('图片上传');
            welcomUploadRef.current.showModal();
        }
    }

    function remove(item, type = 0, index = null) {
        let temp = [];
        if (type === 0) {
            temp = images.filter(file => file.id !== item.id);
            setImages(temp);
            setViewImages(temp);
        } else {
            temp = links.filter((file, i) => i !== index);
            setLinks(temp);
            setViewLinks(temp);
        }
    }

    function renderActiveItem(type = 0) {
        if (type === 0) {
            return images.map((item, i) => (
                <div className={styles.file} key={i}>
                    <Image
                        src={item.urls.file}
                        width={200}
                        height={100}
                        style={{objectFit: 'cover'}}
                    />
                    <MinusCircleOutlined onClick={() => remove(item)} className={styles.icon} />
                </div>
            ));
        } else {
            return links.map((item, i) => (
                <div key={i} className={styles.file}>
                    {item.title}&nbsp;&nbsp;
                    <a href={item.url} target="_blank">
                        ({item.url})
                    </a>
                    &nbsp;&nbsp;
                    <MinusCircleOutlined
                        onClick={() => remove(item, 3, i)}
                        className={styles.icon}
                    />
                </div>
            ));
        }
    }

    function renderDescription(errcode) {
        return (
            <>
                <p>{'错误码：' + errcode}</p>
                <a
                    href={'https://open.work.weixin.qq.com/devtool/query?e=' + errcode}
                    target="_blank"
                >
                    点击查询具体错误
                </a>
            </>
        );
    }

    function afterUpload(data) {
        console.log(1111);
        let temp = {...welcomeData};
        if (key === 1) {
            if (links.length + images.length >= 3) {
                notification.warn({
                    message: '最多添加三个附件,请删除最后上传的图片',
                });
                return;
            } else {
                let tempImages = [...images];
                tempImages.push(data);
                setViewImages(tempImages);
                setImages(tempImages);
            }
            // if (tempImages.length == 2) {
            //     tempImages[1] = data;
            // } else {
            //     tempImages.push(data);
            // }
        } else {
            const {picurl, desc, url, title} = data;
            const link = {
                title,
                desc,
                url,
                picurl,
            };
            let linkArr = [...links];
            linkArr.push(link);
            setViewLinks(linkArr);
            setLinks(linkArr);
        }
        setWelcomeData(temp);
    }

    function changeText(e) {
        setViewText(e.target.value);
        setText(e.target.value);
    }

    function saveOrUpdate(configId) {
        let temp = {...welcomeData};
        temp.attachments = [];
        if (links.length > 0) {
            links.forEach(item => {
                temp.attachments.push({
                    msgtype: 'link',
                    link: item,
                });
            });
        }
        if (images.length > 0) {
            images.forEach(item => {
                temp.attachments.push({
                    msgtype: 'image',
                    image: {attachId: item.id, pic_url: item.urls.file},
                });
            });
        }
        temp.text = {content: text};
        temp.extId = extId;
        setWelcomeData(temp);
        console.log('temp', temp);
        if (configId) {
            updateCustomerWelcomeConfig({configId: configId, searchParams: temp}).then(res => {
                reload();
                notification.success({
                    message: '更新成功',
                });
            });
        } else {
            if (_.isEmpty(selectedUsers)) {
                return;
            } else {
                if (selectedUsers.users.length > 0) {
                    const selectExtIds = selectedUsers.users.map(item => item.id);
                    addCustomerWelcomeConfig({
                        searchParams: temp,
                        extIds: selectExtIds,
                    }).then(res => {
                        reload();
                        notification.success({
                            message: '创建成功',
                        });
                    });
                }
            }
        }
    }

    return (
        <div>
            <Form layout="vertical" style={{margin: '20px'}} {...formLayout}>
                <Form.Item label="消息内容：">
                    <TextArea rows={10} maxLength={2000} onChange={changeText} value={text} />
                </Form.Item>
                {links.length > 0 && (
                    <Form.Item label="链接：">{<>{renderActiveItem(3)}</>}</Form.Item>
                )}
                {images.length > 0 && (
                    <Form.Item label="图片：">
                        {<div className={styles.renderBlock}>{renderActiveItem()}</div>}
                    </Form.Item>
                )}
                <Form.Item {...formLayout}>
                    <Popover
                        content={renderPopoverContent()}
                        title="选择附件类型「最多添加3个附件」"
                        trigger="click"
                        visible={visible}
                        onVisibleChange={visible => setVisible(visible)}
                        placement="bottomLeft"
                    >
                        <Button type="dashed" icon={<PlusOutlined />}>
                            添加附件
                        </Button>
                    </Popover>
                </Form.Item>
            </Form>
            <LinkFormModal
                ref={linkFormRef}
                createLink={afterUpload}
                url={'/welcome'}
                needDesc={true}
            />
            <WelcomUploadModal
                ref={welcomUploadRef}
                category="welcom"
                modalTitle={title}
                type={type}
                afterUpload={afterUpload}
                // afterCloseModal={afterCloseModal}
            />
        </div>
    );
});

ConfigPage.displayName = 'ConfigPage';

export default ConfigPage;
